<template>
  <a-modal
    title="编辑权限"
    :width="500"
    :visible="visible"
    centered
    :maskClosable="false"
    @ok="handleSubmit"
    @cancel="handleCancel()"
    :confirmLoading="confirmLoading"
  >
    <a-spin :spinning="confirmLoading">
      {{ checkedKeys }}
      <a-tree
        v-model="checkedKeys"
        checkable
        :tree-data="options"
        :autoExpandParent="true"
        :replaceFields="{
          title: 'name',
          key: 'id',
          children: 'children',
        }"
      />
    </a-spin>
  </a-modal>
</template>

<script>
import { Setting } from "@/api";
export default {
  components: {},
  data() {
    return {
      confirmLoading: false,
      visible: false,
      formData: {
        name: "", //名称
      },
      form: {},
      options: [],
      checkedKeys: [],
    };
  },
  mounted() {},
  created() {
    this.form = JSON.parse(JSON.stringify(this.formData));
  },
  methods: {
    async open() {
      this.visible = true;
      this.getAllTree();
    },
    // 获取菜单树
    getAllTree() {
      this.confirmLoading = true;
      Setting.loadAuditTree({}).then(res => {
        if (res.code == this.config.pubCode) {
          this.options = res.data;
        }
        this.confirmLoading = false;
      });
    },

    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let newForm = JSON.parse(JSON.stringify(this.form));
          if (this.type == "edit") {
            delete newForm.updateTime;
            delete newForm.createTime;
          }
          this.addsave(newForm);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    // 提交
    addsave(data) {
      this.confirmLoading = true;
      console.log(data);
      Setting.saveRole(data).then(res => {
        if (res.code == this.config.pubCode) {
          this.pubMsg.tipMessage(
            this.type == "edit" ? "编辑成功！" : "添加成功！",
            "success"
          );
          this.handleCancel(1);
        }
        this.confirmLoading = false;
      });
    },
    handleCancel(data) {
      this.$emit("ok", data);
      this.visible = false;
      this.form = JSON.parse(JSON.stringify(this.formData));
      this.$refs.ruleForm.resetFields();
    },
  },
};
</script>
<style lang="less" scoped></style>
